// Module
var code = "<workbench-requirement-templates-modal modal-instance=\"vm.$uibModalInstance\"></workbench-requirement-templates-modal> ";
// Exports
module.exports = code;